import { useEffect, useState } from 'react'
import api from '../api/client'
import SearchableSelect from '../components/SearchableSelect'

function load(key) { try { return JSON.parse(localStorage.getItem(key) || 'null') } catch { return null } }
const fmt = (n) => Number(n || 0).toLocaleString('pt-BR')
const fmtR = (n) => 'R$ ' + Number(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

function No({ node, depth = 0, isAdmin }) {
  if (!node) return null
  return (
    <div style={{ marginLeft: depth * 18 }} className="py-1">
      <div className="bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-100 inline-block min-w-[260px]">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: node.ativo ? '#16a34a' : '#a8a8a8' }} />
          <span className="font-semibold text-sm text-gray-900">{node.nome}</span>
          {node.cargo && node.cargo !== '—' && (
            <span className="text-[11px] px-2 py-0.5 rounded-full font-medium"
              style={{ background: (node.cargo_cor || '#0ea5e9') + '22', color: node.cargo_cor || '#0369a1' }}>{node.cargo}</span>
          )}
        </div>
        <div className="text-xs text-tc-smoke mt-1">
          {[node.cidade, node.estado].filter(Boolean).join(' / ') || 'Local não informado'} · cód {node.codigo_indicacao || '—'}
        </div>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-600 mt-2">
          <span>👥 Clientes: <b>{fmt(node.total_clientes)}</b></span>
          <span>👤 Diretos: <b>{fmt(node.total_diretos ?? node.total_indicados)}</b></span>
          <span>🌐 Equipe: <b>{fmt(node.total_equipe)}</b></span>
        </div>
        <div className="flex flex-wrap gap-x-4 text-xs text-gray-600 mt-1">
          <span>PV: <b>{fmt(node.pv)}</b></span>
          <span>GV: <b>{fmt(node.gv)}</b></span>
          <span className={node.ativo ? 'text-emerald-600' : 'text-gray-400'}>{node.ativo ? '🟢 Ativo' : '⚪ Inativo'}</span>
        </div>
        {isAdmin && node.recorrencia_mensal != null && (
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs mt-2 pt-2 border-t border-gray-100 text-gray-700">
            <span>Recorrência: <b>{fmtR(node.recorrencia_mensal)}</b></span>
            <span>Com. prevista: <b>{fmtR(node.comissao_prevista)}</b></span>
            <span>Com. futura: <b>{fmtR(node.comissao_futura)}</b></span>
          </div>
        )}
      </div>
      {(node.indicados || []).map((ch) => <No key={ch.id} node={ch} depth={depth + 1} isAdmin={isAdmin} />)}
    </div>
  )
}

export default function Rede() {
  const [licenciados, setLic] = useState([])
  const [sel, setSel] = useState('')
  const [tree, setTree] = useState(null)
  const isAdmin = (load('user')?.perfil || '') === 'admin'

  useEffect(() => {
    api.get('/licenciados?limit=100').then((r) => setLic(r.data.data)).catch(() => {})
    const lic = load('licenciado')
    if (lic?.id) setSel(String(lic.id))
  }, [])

  useEffect(() => {
    if (sel) api.get(`/licenciados/${sel}/rede`).then((r) => setTree(r.data)).catch(() => setTree(null))
  }, [sel])

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h1 className="text-2xl font-heading font-bold text-gray-900">Minha Rede</h1>
        <SearchableSelect value={sel} onChange={setSel} placeholder="Selecione um licenciado..." className="w-64"
          options={licenciados.map((l) => ({ value: l.id, label: l.nome }))} />
      </div>
      {!isAdmin && (
        <p className="text-xs text-tc-smoke bg-primary-50/40 rounded-lg px-3 py-2">
          🔒 Por privacidade (LGPD), contatos e dados financeiros de outros licenciados e dos clientes da rede não são exibidos. Você vê seus próprios dados completos no menu correspondente.
        </p>
      )}
      <div>{tree ? <No node={tree} isAdmin={isAdmin} /> : <p className="text-gray-500">Selecione um licenciado para ver a rede.</p>}</div>
    </div>
  )
}
